import AccountsEmpty from './AccountsEmpty';

export default AccountsEmpty;
